import React from "react";
import type { ErrorInfo } from "react";
import { Result } from "antd";
import { CustomButton } from "src/components/ui/Button";
import { cn } from "src/util/cn";
import { withDistributorBasename } from "src/util/distributorBranding.service";

interface ErrorDisplayProps {
  error: Error | null;
  errorInfo: ErrorInfo | null;
  onReset: () => void;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, errorInfo, onReset }) => (
  <div
    className={cn(
      "flex items-center justify-center min-h-screen",
      "bg-[var(--color-gray1)]"
    )}
  >
    <Result
      status="error"
      title="Something went wrong"
      subTitle={error?.message ?? "An unexpected error occurred"}
      extra={[
        <CustomButton key="reset" type="primary" onClick={onReset}>
          Try Again
        </CustomButton>,
        <CustomButton
          key="home"
          type="secondary"
          onClick={() => (window.location.href = withDistributorBasename("/"))}
        >
          Go Home
        </CustomButton>,
      ]}
    >
      {errorInfo != null && import.meta.env.DEV && (
        <div
          className={cn(
            "text-left mt-4 p-4 rounded overflow-auto max-w-2xl",
            "bg-[var(--color-gray2)]"
          )}
        >
          <details>
            <summary className="cursor-pointer font-semibold mb-2 text-[var(--color-gray9)]">
              Error Details (Development Only)
            </summary>
            <pre className="text-xs whitespace-pre-wrap text-[var(--color-gray8)]">
              {errorInfo.componentStack}
            </pre>
          </details>
        </div>
      )}
    </Result>
  </div>
);

export default ErrorDisplay;
